import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { Button } from 'react-bootstrap'
import ReactPlaceholder from 'react-placeholder/lib'
import { useHistory } from 'react-router-dom'
import { useGet, useSaveUpdate } from '../../../hooks/process-data'
import { appUrl, doToast } from '../../../utils'
import { FormCustom } from '../../../components/form'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import SweetAlert2 from 'react-sweetalert2'
import { useSelector } from 'react-redux'
import LoadingIcon from '../../../components/loading/LoadingIcon'

export default function ZoneBoxForm({ idEventZone }) {
  const history = useHistory()
  const [swalProps, setSwalProps] = useState({ show: false })
  const [getRow, setGetRow] = useState({})

  const { id_customers_reservation_event_zone } = useSelector(
    state => state.sessioncustomer
  )

  const { rows, isProcessing, error, setReload } = useGet({
    url: `/event/zone/${idEventZone}/get/public`,
    rowId: idEventZone
  })

  const [ready, setReady] = useState(false)
  const [row, setRow] = useState({
    p_id_event_zone_detail: '',
    p_box_selected: []
  })

  const dataSubmit = useMemo(
    () => ({
      p_id_event_zone: idEventZone,
      p_list_event_zone_detail: row.p_box_selected
        .map(box => box.id_event_zone_detail)
        .toString(),
      p_id_customers_reservation_event_zone: id_customers_reservation_event_zone
    }),
    [row, idEventZone, id_customers_reservation_event_zone]
  )

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/event/zone/insert/detail',
    setReload: _ => {
      setReload(true)
      setReady(false)
      setRow({
        ...row,
        p_box_selected: []
      })

      setSwalProps({
        icon: 'success',
        title: 'Entradas reservadas',
        show: true,
        confirmButtonText: 'Ir al carrito',
        onConfirm: _ => {
          history.push(
            appUrl({
              url: '/carrito'
            })
          )
        },
        didClose: _ => {
          setSwalProps({ show: false })
        }
      })
    }
  })

  useEffect(() => {
    if (error) {
      history.push(appUrl({ url: '/' }))
    } else if (!isProcessing) {
      if (!rows) {
        history.push(appUrl({ url: '/' }))
      } else {
        setGetRow(rows)
        setReady(true)
      }
    }
  }, [rows, error, isProcessing, history])

  const isSoldOut = () =>
    getRow && parseInt(getRow.sold_out, 10) === 1

  const hasDetails =
    getRow?.event_zone_detail && getRow.event_zone_detail.length > 0

  const hasSelection = row.p_box_selected.length > 0

  return (
    <FormCustom
      viewSubmit={false}
      onSubmit={_ => {
        if (
          getRow &&
          parseInt(getRow.sold_out, 10) === 0 &&
          hasDetails
        ) {
          if (hasSelection) {
            setDoSubmit(true)
          } else {
            doToast({
              response: 'warning',
              message: 'Selecciona al menos un box o asiento antes de continuar.',
              toast
            })
          }
        }
      }}
    >
      <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
        {hasDetails && !isSoldOut() && (
          <div className="d-flex flex-column h-100">
            {/* Paso 1: selector */}
            <div className="mb-3">
              <SelectCustom
                valueId={row.p_id_event_zone_detail}
                keyName="event_zone_detail"
                selectText={`${
                  parseInt(getRow.id_type_event_zone, 10) === 3
                    ? 'Selecciona un box'
                    : 'Selecciona un asiento'
                }`}
                options={getRow.event_zone_detail
                  ?.filter(det => {
                    return !row.p_box_selected.find(
                      box =>
                        parseInt(box.id_event_zone_detail, 10) ===
                        parseInt(det.id_event_zone_detail, 10)
                    )
                  })
                  .map(det => ({
                    ...det,
                    name_event_zone_detail:
                      det.column_event_zone + det.row_event_zone,
                    enabled_event_zone_detail: 1
                  }))}
                setRow={setRow}
                row={row}
                selectPops={{
                  onChange: e => {
                    const findBoxSelected =
                      getRow.event_zone_detail.find(
                        det =>
                          parseInt(det.id_event_zone_detail, 10) ===
                          parseInt(e.id_event_zone_detail, 10)
                      )

                    if (findBoxSelected) {
                      setRow({
                        ...row,
                        p_box_selected: [
                          ...row.p_box_selected,
                          {
                            id_event_zone_detail:
                              findBoxSelected.id_event_zone_detail,
                            name_event_zone_detail:
                              findBoxSelected.column_event_zone +
                              findBoxSelected.row_event_zone
                          }
                        ],
                        p_id_event_zone_detail: ''
                      })
                    }
                  }
                }}
                isSort={false}
              />
              <small className="text-muted">
                Agrega uno por uno los lugares que quieres incluir en esta
                reserva.
              </small>
            </div>

            {/* Paso 2: selección actual */}
            <div className="mb-3">
              <div className="border rounded-3 bg-white p-3">
                {hasSelection ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="fw-semibold">
                        Lugares seleccionados
                      </span>
                      <span className="badge bg-primary">
                        {row.p_box_selected.length}{' '}
                        {row.p_box_selected.length === 1
                          ? 'lugar'
                          : 'lugares'}
                      </span>
                    </div>

                    <ul className="list-group list-group-flush">
                      {React.Children.toArray(
                        row.p_box_selected
                          .sort((a, b) => {
                            return (
                              parseInt(a.id_event_zone_detail, 10) -
                              parseInt(b.id_event_zone_detail, 10)
                            )
                          })
                          .map(box => (
                            <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                              <div className="d-flex align-items-center">
                                <i className="fas fa-chair me-2" />
                                <span>{box.name_event_zone_detail}</span>
                              </div>
                              <button
                                type="button"
                                className="btn btn-link btn-sm text-danger text-decoration-none"
                                onClick={_ => {
                                  setRow({
                                    ...row,
                                    p_box_selected:
                                      row.p_box_selected.filter(
                                        boxSelected =>
                                          parseInt(
                                            boxSelected.id_event_zone_detail,
                                            10
                                          ) !==
                                          parseInt(
                                            box.id_event_zone_detail,
                                            10
                                          )
                                      )
                                  })
                                }}
                              >
                                <i className="fa fa-times me-1" />
                                Quitar
                              </button>
                            </li>
                          ))
                      )}
                    </ul>
                  </>
                ) : (
                  <div className="text-muted small">
                    Aún no has añadido ningún box / asiento. Usa el selector de
                    arriba para empezar.
                  </div>
                )}
              </div>
            </div>

            {/* Paso 3: confirmar */}
            <div className="mt-auto">
              <div className="d-flex justify-content-between align-items-center mb-2">
                {hasSelection && (
                  <small className="text-muted">
                    Vas a reservar{' '}
                    <strong>{row.p_box_selected.length}</strong>{' '}
                    {row.p_box_selected.length === 1
                      ? 'lugar seleccionado'
                      : 'lugares seleccionados'}
                    .
                  </small>
                )}
              </div>

              <Button
                size="lg"
                type="submit"
                className="w-100 d-flex justify-content-center align-items-center"
                disabled={!hasSelection}
              >
                <i className="fas fa-check-circle me-2" />
                <span>Confirmar selección y continuar</span>
              </Button>
            </div>
          </div>
        )}

        {(!hasDetails || isSoldOut()) && (
          <div className="alert alert-danger mb-0">
            <i className="fas fa-exclamation-triangle me-2" />
            <span>Entradas agotadas para esta zona.</span>
          </div>
        )}
      </ReactPlaceholder>

      {doSubmit && <LoadingIcon />}

      <SweetAlert2 {...swalProps} />
    </FormCustom>
  )
}
